import React, { memo } from 'react';
import { styled } from '@linaria/react';
import { Flex } from '@vio/atlas/helpers/Flex';
import { Icon } from '@vio/atlas/Icon';
import { Pill } from '@vio/atlas/Pill';
import { FilterUrlParams } from 'modules/search/types';
import { isFacetSelected } from 'utils/filters';
const _exp = /*#__PURE__*/() => Flex.Row;
const PillWrapper = /*#__PURE__*/styled(_exp())({
  name: "PillWrapper",
  class: "p1bewmud",
  propsAsIs: true
});
interface Props {
  onChange: (filterKey: keyof FilterUrlParams, filterValue: string | null | undefined) => void;
  value: FilterUrlParams['starRatings'];
}
const StarRatingFilterComponent: React.FC<Props> = ({
  onChange,
  value
}) => {
  const starRatings = ['1', '2', '3', '4', '5'];
  return <PillWrapper gap="s300">
      {starRatings.map(rating => {
      const isActive = isFacetSelected(value, rating);
      return <Pill key={rating} isSelected={isActive} iconEnd={<Icon name="StarSolid" />} onClick={() => onChange('starRatings', rating)}>
            {rating}
          </Pill>;
    })}
    </PillWrapper>;
};
export const StarRatingFilter = memo(StarRatingFilterComponent);

require("./StarRatingFilter.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./StarRatingFilter.tsx");